import {Injectable} from '@angular/core';
import {ApiService} from './api/api.service';
import {Company} from '../classes/company';
import {Azureteam} from '../classes/azureteam';
import {Observable} from 'rxjs';
import {AzureFeature} from '../classes/azurefeature';

@Injectable({
    providedIn: 'root'
})
export class CompanyService {

    constructor(public apiService: ApiService) {
    }

    getCompany(id: number) {
        return this.apiService.getCallData$<Company>(`companies/${id}`);
    }

    getCompanies(withAzureProject = false) {
        return this.apiService.getCallData$<Company[]>('companies', {withAzureProject});
    }

    saveCompany(company: Company) {
        return this.apiService.postCall$<Company>('companies', company);
    }

    deleteCompany(companyId: number) {
        return this.apiService.deleteCall(`companies/${companyId}`);
    }

    getAzureTeams(): Observable<{ value: Azureteam[] }> {
        return this.apiService.getCallData$<{ value: Azureteam[] }>('companies/azureteams');
    }

    getAzureItems(companyId: number): Observable<any> {
        return this.apiService.getCallData$<any>('companies/azureitems', {companyId});
    }

    getAzureFeatures(companyId: number): Observable<any> {
        return this.apiService.getCallData$<AzureFeature[]>('companies/azurefeatures', {companyId});
    }

    getHavingRegistrations(): Observable<Company[]> {
        return this.apiService.getCallData$<Company[]>('companies/havingregistrations', null);
    }
}
